import React from 'react';
import { MenuItem } from '../../styles/ProjectSettingsMenu.styles';

const SettingsMenu = ({
    isAdmin,
    archivedCards,
    onSectionChange,
    limitColumnHeight,
    onToggleLimitColumnHeight,
    enableGithubLinks, // Add new prop
    onToggleEnableGithubLinks, // Add new handler prop
    onExportProject // Export handler prop
}) => (
    <>
        <MenuItem onClick={() => onSectionChange('background')}>
            Change background
        </MenuItem>
        <MenuItem onClick={() => onSectionChange('members')}>
            Manage members
            {isAdmin && (
                <span style={{ marginLeft: '4px', fontSize: '12px' }}>
                    (Admin)
                </span>
            )}
        </MenuItem>
        <MenuItem onClick={() => onSectionChange('archived')}>
            View archived items
            {archivedCards.length > 0 && (
                <span style={{ marginLeft: '4px', color: '#8C9BAB' }}>
                    ({archivedCards.length})
                </span>
            )}
        </MenuItem>
        <MenuItem onClick={onToggleLimitColumnHeight}>
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <path d="M3 9h18" />
                <path d="M9 21V9" />
            </svg> */}
            {limitColumnHeight ? 'Disable Column Height Limit' : 'Enable Column Height Limit'}
        </MenuItem>
        <MenuItem onClick={onToggleEnableGithubLinks}>
            {enableGithubLinks ? 'Disable GitHub PR Links' : 'Enable GitHub PR Links'}
        </MenuItem>
        <MenuItem onClick={() => onSectionChange('activity')}>
            View Activity
        </MenuItem>
        {onExportProject && (
            <MenuItem onClick={onExportProject}>
                Export project as JSON
            </MenuItem>
        )}
    </>
);

export default SettingsMenu;
